// extracted by mini-css-extract-plugin
module.exports = {"renderTitle":"style_renderTitle__1OiQM","title":"style_title__12hMO","objectRolesModal":"style_objectRolesModal__3Xa7o"};